import { atom } from "jotai";

export const debugModeOpenAtom = atom(false);
